import React from 'react'

const ExpandReach = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={70}
                height={70}
                x={0}
                y={0}
                viewBox="0 0 64 64"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        fill="#ffc200"
                        d="M58 34a2 2 0 0 1-2-2c0-4.729-9.856-10-24-10S8 27.271 8 32a2 2 0 0 1-4 0c0-7.851 12.299-14 28-14s28 6.149 28 14a2 2 0 0 1-2 2z"
                        opacity={1}
                        data-original="#c80a50"
                        className=""
                    />
                    <circle
                        cx={32}
                        cy={32}
                        r={22}
                        fill="#60a9eb"
                        opacity={1}
                        data-original="#00a0c8"
                        className=""
                    />
                    <path
                        fill="#1975c9"
                        d="m37.6 44.2-4-3a1.001 1.001 0 0 0-1.6.8v1c-9.773 0-17.498-2.516-21.34-5.632a21.84 21.84 0 0 0 2.563 6.1C18.155 45.674 24.711 47 32 47v1a1.001 1.001 0 0 0 1.6.8l4-3a.998.998 0 0 0 0-1.6zM32.384 28.713l2.712 5.716a1.002 1.002 0 0 0 1.808-.001l2.712-5.716a4 4 0 1 0-7.232.001zM14.415 18.778l2.681 5.65a1.001 1.001 0 0 0 1.808 0l2.712-5.716a4 4 0 0 0-1.597-5.166 22.116 22.116 0 0 0-5.604 5.232zM48.904 20.428l.744-1.567a22.13 22.13 0 0 0-5.604-5.275c.058.397.175.776.341 1.126l2.712 5.716a.999.999 0 0 0 1.807 0z"
                        opacity={1}
                        data-original="#0082aa"
                        className="hovered-path"
                    />
                    <path
                        fill="#1975c9"
                        d="M48 36a1 1 0 0 0-1-1h-2c-.552 0-1-.448-1-1s-.448-1-1-1-1-.448-1-1-.448-1-1-1-1-.448-1-1-.448-1-1-1h-8c-.552 0-1-.448-1-1s-.448-1-1-1-1-.448-1-1-.448-1-1-1h-2a1 1 0 0 1 0-2c.552 0 1-.448 1-1s.448-1 1-1h2c.552 0 1-.448 1-1s.448-1 1-1 1-.448 1-1 .448-1 1-1 1-.448 1-1 .448-1 1-1h4a1 1 0 0 0 0-2 1 1 0 0 1-1-1v-1H25.424A21.952 21.952 0 0 0 18 15.029V20c0 .552.448 1 1 1s1 .448 1 1v2c0 .552.448 1 1 1s1 .448 1 1 .448 1 1 1 1 .448 1 1 .448 1 1 1h2a1 1 0 0 1 1 1v6c0 .552.448 1 1 1s1 .448 1 1 .448 1 1 1 1 .448 1 1 .448 1 1 1 1 .448 1 1v8a1 1 0 0 0 2 0c0-.552.448-1 1-1s1-.448 1-1 .448-1 1-1 1-.448 1-1 .448-1 1-1 1-.448 1-1 .448-1 1-1 1-.448 1-1v-2c0-.552.448-1 1-1s1-.448 1-1 .448-1 1-1 1-.448 1-1z"
                        opacity={1}
                        data-original="#0082aa"
                        className="hovered-path"
                    />
                    <path
                        fill="#3b8ad1"
                        d="M18 19c0 .552.448 1 1 1s1 .448 1 1v2c0 .552.448 1 1 1s1 .448 1 1 .448 1 1 1 1 .448 1 1 .448 1 1 1h2a1 1 0 0 1 1 1v6c0 .552.448 1 1 1s1 .448 1 1 .448 1 1 1 1 .448 1 1 .448 1 1 1 1 .448 1 1v8a1 1 0 0 0 2 0c0-.552.448-1 1-1s1-.448 1-1 .448-1 1-1 1-.448 1-1 .448-1 1-1 1-.448 1-1 .448-1 1-1 1-.448 1-1v-2c0-.552.448-1 1-1s1-.448 1-1 .448-1 1-1a1 1 0 0 0 0-2h-2c-.552 0-1-.448-1-1s-.448-1-1-1-1-.448-1-1-.448-1-1-1-1-.448-1-1-.448-1-1-1h-8c-.552 0-1-.448-1-1s-.448-1-1-1-1-.448-1-1-.448-1-1-1h-2a1 1 0 0 1 0-2c.552 0 1-.448 1-1s.448-1 1-1h2c.552 0 1-.448 1-1s.448-1 1-1 1-.448 1-1 .448-1 1-1 1-.448 1-1 .448-1 1-1h4a1 1 0 0 0 0-2 1 1 0 0 1-1-1v-.172A22.032 22.032 0 0 0 32 10a21.906 21.906 0 0 0-14 5.029z"
                        opacity={1}
                        data-original="#fab400"
                        className=""
                    />
                    <path
                        fill="#1975c9"
                        d="M37.6 44.2 34 41.5v7l3.6-2.7a.998.998 0 0 0 0-1.6zM39 28h-6.874c.064.248.151.486.258.713l2.712 5.716a1.002 1.002 0 0 0 1.808-.001l2.712-5.716c.055-.116.104-.235.148-.357A.996.996 0 0 0 39 28z"
                        opacity={1}
                        data-original="#dc9600"
                        className=""
                    />
                    <path
                        fill="#ffc200"
                        d="m37.6 43.2-4-3a1 1 0 0 0-1.6.8v1C17.856 42 8 36.729 8 32H4c0 7.851 12.299 14 28 14v1a1.001 1.001 0 0 0 1.6.8l4-3a.998.998 0 0 0 0-1.6z"
                        opacity={1}
                        data-original="#c80a50"
                        className=""
                    />
                    <path
                        fill="#c5dcf1"
                        d="M52 12a4 4 0 1 0-7.616 1.713l2.712 5.716a1.002 1.002 0 0 0 1.808-.001l2.712-5.716A3.985 3.985 0 0 0 52 12z"
                        opacity={1}
                        data-original="#0a5078"
                        className=""
                    />
                    <circle
                        cx={48}
                        cy={12}
                        r={2}
                        fill="#1975c9"
                        opacity={1}
                        data-original="#f0f0f0"
                        className=""
                    />
                    <path
                        fill="#c5dcf1"
                        d="M40 26a4 4 0 1 0-7.616 1.713l2.712 5.716a1.002 1.002 0 0 0 1.808-.001l2.712-5.716A3.985 3.985 0 0 0 40 26z"
                        opacity={1}
                        data-original="#0a5078"
                        className=""
                    />
                    <circle
                        cx={36}
                        cy={26}
                        r={2}
                        fill="#1975c9"
                        opacity={1}
                        data-original="#f0f0f0"
                        className=""
                    />
                    <path
                        fill="#c5dcf1"
                        d="M22 16a4 4 0 1 0-7.616 1.713l2.712 5.716a1.002 1.002 0 0 0 1.808-.001l2.712-5.716A3.985 3.985 0 0 0 22 16z"
                        opacity={1}
                        data-original="#0a5078"
                        className=""
                    />
                    <circle
                        cx={18}
                        cy={16}
                        r={2}
                        fill="#1975c9"
                        opacity={1}
                        data-original="#f0f0f0"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default ExpandReach